<template>
  <div class="apply-partner" v-title data-title="申请流程">
    <section>
      <div class="process">
        <slot name='top'>

        </slot>
        <div class="schedule">
          <dl class="msg">
            <dt>
              <img src="../../assets/images/partner-img/3.png" alt="">
            </dt>
            <dd>
              信息填写
            </dd>
          </dl>
          <img src="../../assets/images/partner-img/4.png" alt="" class="line">
          <slot name='left'>

          </slot>
          <img src="../../assets/images/partner-img/4.png" alt="" class="line">
          <slot name="right">

          </slot>
        </div>
      </div>
    </section>
  </div>
</template>
<script>


export default {
  data(){
    return{

    }
  },
  components:{

  }
}
</script>
<style lang="less" scoped>
  .apply-partner{
    section{

      // 流程
      .process{
        width: 7.1rem;
        height: 3.22rem;
        margin: 0 auto;
        margin-top: .3rem;
        background: #ffffff;
        border-radius: .1rem;
        overflow: hidden;
        // 标题
        .title{
          text-align: center;
          font-size: 0.36rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: #222222;
          line-height: .36rem;
          margin-top: .4rem;
          line-height: .36rem;
        }
        // 流程
        .schedule{
          display: flex;
          margin-top: .87rem;
          dl{
            text-align: center;
            dt{

            }
            dd{
              font-size: 0.24rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #222222;
              margin-top: .21rem;
            }
          }
          .msg{
            margin-left: .61rem;
            margin-right:.37rem;
            dt{
              img{
                width: .44rem;
                height: .39rem;
              }
            }
            dd{
                
            }
          }
          .contract{
            margin-left: .37rem;
            margin-right: .35rem;
            dt{
              img{
                width: .52rem;
                height: .39rem;
              }
            }
          }
          .prove{
            margin-left:.29rem;
            dt{
              img{
                width: .39rem;
                height: .39rem;
              }
            }
          }
          .line{
            margin-top: .4rem;
            width: .81rem;
            height: .02rem;
          }
        }
        .bottom{

        }
      }
    }
  }
</style>